/*
 * carousel.js -- sipky, tecky a drzeni polozky po rotaci zarizeni
 * (plan 08-08, KOMP-02).
 *
 * CO TENHLE MODUL NENI: SWIPE ENGINE.
 *
 * Pas se ovlada prstem BEZ jedineho radku skriptu -- je to nativni
 * posuvny kontejner (`overflow-x: auto` + `scroll-snap-type: x mandatory`,
 * `components.css`). Kontrakt mobilniho chovani to pise doslova: „relativni
 * sirky s peekem 12-15 %, nativni overflow (ZADNY vlastni swipe engine),
 * stejna konvence sipek/tecek, po rotaci zarizeni drzi aktualni polozku".
 * Vlastni engine (touchstart/touchmove/transform) by musel znovu vyrobit
 * setrvacnost, gumovy okraj i integraci s ovladanim systemu -- a delal by
 * to hur nez prohlizec.
 *
 * MODUL PROTO DELA JEN TRI VECI:
 *
 *   1. SIPKY posunou pas o JEDNU polozku (`scrollBy`). Jsou to `<button>`,
 *      takze klavesnici umi nativne; obsluha se vesi az tady, a proto jsou
 *      do initu v CSS skryte (`html.carousel-ready`).
 *   2. TECKY skoci na polozku a drzi `aria-current`. Aktualni index se
 *      dopocitava z pozice pri scrollu (throttlovane).
 *   3. DRZENI POLOZKY PO ZMENE ROZMERU -- rozhodnuti otevrene otazky #6
 *      kontraktu, viz nize.
 *
 * ZADNA AUTOROTACE. V tomhle souboru neni `setInterval` ani `setTimeout`
 * s opakovanim. Pas, ktery se hybe sam, bere uzivateli kontrolu (WCAG
 * 2.2.2) a kontrakt ho zakazuje u vsech ctyr pouziti.
 *
 * OTEVRENA OTAZKA #6 -- SCROLLLEFT, NEBO INDEX?
 *
 * Kontrakt rika „po rotaci zarizeni drzi aktualni polozku", ale neurcuje,
 * jestli se pozice dopocitava ze `scrollLeft`, nebo z INDEXU. Tenhle modul
 * rozhoduje pro INDEX a duvod je aritmeticky: sirka polozky je RELATIVNI
 * (procenta sirky pasu), takze po rotaci 390 -> 844 px se zmeni. Zachovany
 * `scrollLeft` by tedy ukazal na jine misto pasu -- pri peeku 12 % je
 * `2 * 343 px` v pase o polozkach sirokych 743 px necela polovina PRVNI
 * karty. Ulozeny index 2 nasobeny NOVOU sirkou polozky ukaze na tutez
 * kartu.
 *
 * INDEX SE CTE PRI SCROLLU, NE AZ PRI ROTACI. `resize` uz totiz prijde
 * s NOVYMI rozmery: kdyby se index pocital az v nem, delil by se
 * `scrollLeft` (stary) novou sirkou polozky a vysledek by byl nahodny.
 * Modul si proto drzi POSLEDNI ZNAMY index z posluchace scrollu a po
 * zmene rozmeru z nej pozici jen dopocita.
 *
 * KROK = SIRKA POLOZKY + MEZERA. `offsetWidth` mezeru neobsahuje, takze
 * bez `column-gap` by se chyba scitala: u sesti polozek a mezery 14 px je
 * to 70 px, tedy skoro cela peek zona. Mezera se cte z vypoctenych stylu
 * pasu, ne z konstanty -- breakpointy ji meni a modul je neopisuje.
 *
 * `behavior: 'instant'` SE NEPOUZIVA. Hodnota `instant` je v Safari
 * matice podpory neznama a cely `scrollTo({...})` s options objektem tam
 * konci vyjimkou (vzor `hero.js` 08-07: plynuly posun je Safari 15.4+).
 * Prirazeni `track.scrollLeft = x` je okamzite, funguje vsude a chova se
 * presne tak, jak reposice po rotaci ma -- bez animace.
 *
 * `html.carousel-ready` ZNACI „modul dobehl", ne „modul bezi" -- stejne
 * jako `menu-ready` (07-03) a `hero-ready` (08-07). Tridou se odkryvaji
 * SIPKY A TECKY, tedy ovladaci prvky. Kdyby prisla na prvnim radku,
 * existovalo by okno, kdy jsou videt a klik nic nedela (kontrakt B).
 *
 * BEZPECNOST (threat model 08-08, T-08-08-01): zadny `innerHTML`, zadny
 * `eval`, zadna interpolace vstupu. Modul sahne jen na `scrollLeft`,
 * `scrollBy`, `setAttribute('aria-current')` a `classList`. Nesaha na
 * `document.body.classList` -- stavy tela jsou vyhradne kontrakt
 * `state.js` a pas zadny novy nepotrebuje.
 */

/** Trida na <html>: "carousel modul dobehl" (analogie `menu-ready`). */
const READY_CLASS = 'th-carousel-ready';

/** Jak dlouho se po scrollu ceka, nez se prepocita index (ms). */
const SCROLL_THROTTLE = 90;

/** Jak dlouho se po zmene rozmeru ceka na dopocet noveho rozvrzeni (ms). */
const RESIZE_DEBOUNCE = 140;

/**
 * Posledni znama sirka viewportu (1.27.13, koordinatoruv nalez).
 * `reposition()` mutuje DOM (`scrollLeft` + `aria-current` pres
 * `markDot()`) -- pri cisté zmene VYSKY (iOS lista adresy po tapu) by
 * takova mutace mohla spadnout do hover faze tapu a WebKit by klik
 * zahodil, presne jako u docku/reelu. Sirka je jedina rozmerova zmena,
 * po ktere ma pas skutecne co prepocitavat (peek/pocet polozek na
 * obrazovku zavisi na sirce, ne na vysce).
 */
let carouselLastWidth = window.innerWidth;

/**
 * Zmenila se od posledniho volani skutecna SIRKA viewportu? Vedlejsim
 * efektem si zapamatuje novou hodnotu, takze druhe volani za sebou vraci
 * `false`, dokud se sirka znovu nezmeni.
 *
 * @return {boolean}
 */
function widthChanged() {
	const now = window.innerWidth;
	const changed = now !== carouselLastWidth;
	carouselLastWidth = now;
	return changed;
}

/**
 * Bezpecne prevede NodeList na staticke pole.
 *
 * @param {string} selector CSS selektor.
 * @param {ParentNode} [root] Koren hledani.
 * @return {Array<Element>}
 */
function all(selector, root) {
	return Array.prototype.slice.call((root || document).querySelectorAll(selector));
}

/**
 * Krok pasu = sirka jedne polozky + mezera mezi polozkami.
 *
 * @param {Element} track Posuvny kontejner.
 * @return {number} Krok v px (0, kdyz pas nema polozky).
 */
function stepOf(track) {
	const first = track.querySelector('.th-carousel-item');

	if (!first) {
		return 0;
	}

	const styles = window.getComputedStyle(track);
	const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;

	return first.offsetWidth + gap;
}

/**
 * Oznaci aktivni tecku (a odznaci ostatni).
 *
 * @param {Array<Element>} dots Tecky.
 * @param {number} index Poradi aktivni polozky.
 * @return {void}
 */
function markDot(dots, index) {
	dots.forEach(function (dot, i) {
		if (i === index) {
			dot.setAttribute('aria-current', 'true');
		} else {
			dot.removeAttribute('aria-current');
		}
	});
}

/**
 * Navesi obsluhu na jeden pas.
 *
 * @param {Element} root Koren komponenty (`.carousel`).
 * @return {void}
 */
function setupCarousel(root) {
	const track = root.querySelector('.th-carousel-track');

	if (!track) {
		return;
	}

	const items = all('.th-carousel-item', track);
	const dots = all('.th-carousel-dot', root);
	const navs = all('.th-carousel-nav', root);

	if (!items.length) {
		return;
	}

	/*
	 * POSLEDNI ZNAMY INDEX. Drzi se tady, ne v DOM: `resize` prijde uz
	 * s novymi rozmery, takze v nem uz se index z pozice spocitat neda.
	 */
	let index = 0;

	function clamp(value) {
		return Math.max(0, Math.min(items.length - 1, value));
	}

	function readIndex() {
		const step = stepOf(track);

		if (step <= 0) {
			return 0;
		}

		return clamp(Math.round(track.scrollLeft / step));
	}

	function goTo(next) {
		const step = stepOf(track);

		index = clamp(next);

		if (step > 0) {
			track.scrollLeft = index * step;
		}

		markDot(dots, index);
	}

	let scrollTimer = null;

	track.addEventListener('scroll', function () {
		if (scrollTimer !== null) {
			return;
		}

		scrollTimer = window.setTimeout(function () {
			scrollTimer = null;
			index = readIndex();
			markDot(dots, index);
		}, SCROLL_THROTTLE);
	}, { passive: true });

	navs.forEach(function (btn) {
		btn.addEventListener('click', function () {
			const dir = parseInt(btn.getAttribute('data-carousel-dir'), 10) || 1;

			/*
			 * Nova pozice se pocita z AKTUALNI, ne z ulozene: uzivatel mohl
			 * mezitim posunout pas prstem a posluchac scrollu je
			 * throttlovany, takze `index` muze byt o kolo pozadu.
			 */
			goTo(readIndex() + dir);
		});
	});

	dots.forEach(function (dot, i) {
		dot.addEventListener('click', function () {
			goTo(i);
		});
	});

	markDot(dots, 0);

	return function reposition() {
		/* Po zmene rozmeru: tyz INDEX, nova sirka polozky. */
		const step = stepOf(track);

		if (step > 0) {
			track.scrollLeft = index * step;
		}

		markDot(dots, index);
	};
}

/**
 * Ovladani pauzy automaticky posouvanych pasu (WCAG 2.2.2).
 *
 * Pas recenzi (`.revpas`) se posouva sam a dele nez 5 sekund. Do 08-16b
 * mel jedinou pauzu -- `:hover` -- tedy zadnou pro klavesnici ani dotyk.
 * Tlacitko prepina atribut `data-paused` na SVEM pasu; zastaveni same
 * pak resi CSS (`animation-play-state`), JS nic neanimuje.
 *
 * Tlacitko se hleda SCOPOVANE (`:scope > [data-revpas-toggle]`), ne
 * globalne: pri dvou pasech na strance by `document.querySelector` sahnul
 * vzdycky na ten prvni a druhy by prestal fungovat.
 *
 * Pristupna jmena obou stavu nese markup (`data-label-pause` /
 * `data-label-play`) -- v JS zadny zadratovany text (N8).
 *
 * @return {void}
 */
function setupPausableStrips() {
	all('[data-revpas-toggle-root]').forEach(function (strip) {
		const toggle = strip.querySelector(':scope > [data-revpas-toggle]');

		if (!toggle) {
			return;
		}

		const labelPause = toggle.getAttribute('data-label-pause') || '';
		const labelPlay = toggle.getAttribute('data-label-play') || '';

		toggle.addEventListener('click', function () {
			const paused = strip.hasAttribute('data-paused');

			if (paused) {
				strip.removeAttribute('data-paused');
			} else {
				strip.setAttribute('data-paused', '');
			}

			toggle.setAttribute('aria-pressed', paused ? 'false' : 'true');

			const label = paused ? labelPause : labelPlay;

			if (label) {
				toggle.setAttribute('aria-label', label);
			}
		});
	});
}

/**
 * Spusti modul pasu.
 *
 * @return {void}
 */
export function init() {
	setupPausableStrips();

	const roots = all('.th-carousel');

	if (!roots.length) {
		return;
	}

	const repositions = [];

	roots.forEach(function (root) {
		const reposition = setupCarousel(root);

		if (typeof reposition === 'function') {
			repositions.push(reposition);
		}
	});

	if (repositions.length) {
		let resizeTimer = null;

		const onResize = function () {
			/*
			 * HEIGHT-ONLY IGNOROVAT (1.27.13, koordinatoruv nalez): iOS
			 * lista adresy se schova/ukaze po prvnim tapu po scrollu a
			 * vystreli `resize` se ZMENENOU VYSKOU, ale STEJNOU SIRKOU.
			 * `reposition()` na takovou udalost nema co reagovat (peek
			 * i pocet polozek na obrazovku zavisi na sirce) a jeji mutace
			 * (`scrollLeft`, `aria-current`) by mohla spadnout do hover
			 * faze prave probihajiciho tapu.
			 */
			if (!widthChanged()) {
				return;
			}

			if (resizeTimer !== null) {
				window.clearTimeout(resizeTimer);
			}

			/*
			 * Debounce: behem otaceni telefonu prijde `resize` desetkrat
			 * a kazde prirazeni `scrollLeft` uprostred zmeny rozvrzeni by
			 * pas rozhoupalo. Ceka se, az se rozmery ustali.
			 */
			resizeTimer = window.setTimeout(function () {
				resizeTimer = null;
				repositions.forEach(function (fn) {
					fn();
				});
			}, RESIZE_DEBOUNCE);
		};

		window.addEventListener('resize', onResize);

		/*
		 * `orientationchange` je zamerne VEDLE `resize`, ne misto nej.
		 * Cast prohlizecu matice podpory po otoceni `resize` vubec
		 * neposle, jina cast posle obe udalosti -- debounce z toho udela
		 * jednu reposici, takze duplicita nic nestoji.
		 */
		window.addEventListener('orientationchange', onResize);
	}

	// AZ NA KONCI: tridou se odkryvaji sipky a tecky, ktere uz maji obsluhu.
	document.documentElement.classList.add(READY_CLASS);
}
